module.exports = __webpack_public_path__ + "assets/aa8c33064948002cc1f6631764652648.svg";